/* eslint-disable no-underscore-dangle */
import { Component, AfterViewInit, EventEmitter, Input, Output,
    ViewChildren, ViewContainerRef, QueryList, OnChanges } from '@angular/core';

import { HisAuthService, HisBaseGlobalsService, HisUiService } from 'hisng';

import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { DataDictionaryUtils } from 'app/fs/res/common/utils/data-dictionary-utils';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { Publication } from 'app/fs/res/publication/model/publication';
import { DynamicContentUtils } from 'app/fs/res/common/service/dynamic-content/dynamic-content-utils';
import { PublicationCreator } from 'app/fs/res/publication/model/publication-creator';

@Component( {
    selector: 'res-publication-edit-contact-data',
    templateUrl: './publication-edit-contact-data.component.html',
    providers: [ProviderManager.getComponentProvider(PublicationEditContactDataComponent)],
} )
export class PublicationEditContactDataComponent implements AfterViewInit {
    @Input() publication: Publication;
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    public contactDialogVisibility = false;
    public creator: PublicationCreator;

    constructor(
        public auth: HisAuthService,
        public hisBaseGlobalsService: HisBaseGlobalsService,
        public dynamicContentUtils: DynamicContentUtils,
        public hisUiService: HisUiService) {
    }

    ngAfterViewInit() {
        // trigger re-render count of ViewChildren dynamicFieldContainer
        this.fieldViewContainerList.changes.subscribe( (changes: any) => {
            // eslint-disable-next-line no-underscore-dangle
            if ( this.publication._dynamicComponent && this.hisBaseGlobalsService.isAnyModuleActive( 'HISINONERES' ) ) {
                // eslint-disable-next-line no-underscore-dangle
                this.publication._dynamicComponent = { ...this.publication._dynamicComponent };
            }
            console.log( 'fieldViewContainerList.toArray().length: ', this.fieldViewContainerList.toArray().length );
        } );
    }

    public isHidden( ddKey: string ) {
        return this.hisBaseGlobalsService.getDd(ddKey)?.hidden;
    }

    public addContact() {
        this.creator = null;
        this.contactDialogVisibility = true;
    }

    public deleteContact( event: PublicationCreator ) {
        const index = this.publication.creators.findIndex(c => c.person?.id == event.person.id);
        this.publication.creators[index].isPublicationContact = false;
        this.publication.creators[index].email = null;
    }

    public editContact( creator: PublicationCreator ) {
        this.creator = JSON.parse(JSON.stringify(creator));
        this.contactDialogVisibility = true;
    }

    public creatorChange( event: PublicationCreator ): void {
        if (event?.person?.id) {
            const index = this.publication.creators.findIndex(c => c.person?.id == event.person.id);
            this.publication.creators[index] = event;
        }
    }

    getCreatorContactFromPublication() {
        return this.publication?.creators?.filter(c => c.isPublicationContact && c.person);
    }

    noInternalPersonAssigned() {
        return !this.publication?.creators?.some(c => c.person?.id);
    }

    disableAddContactBtn() {
        return !this.publication?.creators?.some(c => c.person?.id && !c.isPublicationContact);
    }
}
